import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import FormPage from './pages/FormPage';
import WaitingPage from './pages/WaitingPage';
import ThankYouPage from './pages/ThankYouPage';
import CancelPage from './pages/CancelPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Hauptseite: Formular eingebettet */}
        <Route path="/" element={<FormPage />} />

        {/* Zwischenseite: Polling auf n8n, dann Redirect zu Stripe */}
        {/* Phase 1: ?cid=<correlation_id>          → wartet auf Stripe-URL */}
        <Route path="/waiting" element={<WaitingPage />} />

        {/* Stripe success_url landet hier */}
        <Route path="/thank-you" element={<ThankYouPage />} />

        {/* Stripe cancel_url landet hier */}
        <Route path="/cancelled" element={<CancelPage />} />
      </Routes>
    </BrowserRouter>
  );
}
